import { Component } from '@angular/core'
import {
    selectHierarchicalSelectionRootName,
    selectSelectionState,
} from '../../state/selection/selection.selectors'
import { Store } from '@ngrx/store'
import { SelectionType } from 'src/app/state/selection/selection.state'
import { selectCaseCellTypeDetectionResults } from 'src/app/state/case/case.selectors'
import { take } from 'rxjs'
import { CellTypeDetectionResult } from 'src/app/state/case/case.state'
import { ToasterService } from 'src/app/shared/services/toaster.service'
import { DownloadService } from 'src/app/shared/services/download.service'
import { HttpErrorResponse } from '@angular/common/http'

@Component({
    selector: 'app-hierarchical-selection-panel',
    templateUrl: './hierarchical-selection-panel.component.html',
    styleUrls: ['./hierarchical-selection-panel.component.scss'],
})
export class HierarchicalSelectionPanelComponent {
    isUnsupervisedSelection = false
    resolution = 6
    cellTypeDetectionResults: CellTypeDetectionResult[] = []
    readonly currentHierarchicalSelectionRootName$ = this.store.select(
        selectHierarchicalSelectionRootName
    )
    readonly cellTypeDetectionResults$ = this.store.select(selectCaseCellTypeDetectionResults)

    constructor(
        private readonly store: Store,
        private downloadService: DownloadService,
        private toaster: ToasterService
    ) {
        this.store
            .select(selectSelectionState)
            .pipe()
            .subscribe(state => {
                if (state.type === SelectionType.Unsupervised) {
                    this.isUnsupervisedSelection = true
                    this.resolution = state.resolution
                    this.cellTypeDetectionResults$.pipe(take(1)).subscribe(results => {
                        this.cellTypeDetectionResults = results
                    })
                } else {
                    this.isUnsupervisedSelection = false
                }
            })
    }

    downloadData(cellTypeDetectionResult: CellTypeDetectionResult): void {
        this.downloadService
            .downloadAutoCellTypeDetections(cellTypeDetectionResult.download)
            .subscribe({
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(
                        err,
                        `Failed to download cell type detection ${cellTypeDetectionResult.name}.`
                    )
                },
            })
    }

    getImageUrl(cellTypeDetectionResult: CellTypeDetectionResult): string {
        return this.resolution !== 10 // js is not able to handle 1.0 as a key
            ? cellTypeDetectionResult.image[Number((this.resolution / 10).toFixed(1))]
            : Object.values(cellTypeDetectionResult.image).at(-1)
    }

    openImage(imageUrl: string): void {
        window.open(imageUrl, '_blank')
    }
}
